import { range } from 'lodash';
import {
  AccountFormLoader,
  AccountWithdrawalLoader,
  MarketLoader,
  NotificationLoader,
  MarketSharesItemLoader,
  MarketWidgetLoader,
  BiggestGainsLoader,
  TableRowsLoader,
  LeaderboardsInfoLoader,
  OverviewMapLoader,
  MarketChartLoader,
  PreviewCarouselLoader,
  StaticPageLoader,
  MarketDetailPageLoader,
  SocialsLoader,
  ContractInfoLoader,
} from '@/components/content-loader';

const contentLoaderMixin = {
  components: {
    AccountFormLoader,
    AccountWithdrawalLoader,
    LeaderboardsInfoLoader,
    MarketLoader,
    MarketSharesItemLoader,
    MarketWidgetLoader,
    NotificationLoader,
    BiggestGainsLoader,
    TableRowsLoader,
    OverviewMapLoader,
    MarketChartLoader,
    PreviewCarouselLoader,
    StaticPageLoader,
    MarketDetailPageLoader,
    SocialsLoader,
    ContractInfoLoader,
  },
  data() {
    return {
      isComponentReady: false,
    };
  },
  methods: {
    loaderItems(number) {
      return range(0, number);
    },
  },
};

export default contentLoaderMixin;
